import styled from 'styled-components';

import { SPACE } from '../../../../theme/tokens';
import { IngredientsHeading } from '../IngredientsHeading';

/** The Ingredients heading as the sheet's header: the header's own padding spaces it, so it drops the rail's foot. */
export const SheetHeading = styled(IngredientsHeading)`
  margin-bottom: ${SPACE[0]};
`;
